var utils = require('./walnut/utils');
var event = require('./walnut/event');

var walnut = {
  utils: utils,
  event: event
};

module.exports = walnut;
